module.exports = __webpack_public_path__ + "static/media/clock-seven.2dd0f62c.svg";